import React, { useState } from "react";
import axios from "axios";
import "../styles/PageForgotPassword.css";
import ButtonRegular from "./ui/ButtonRegular";

function PageForgotPassword() {
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setMessage("");

		try {
			const res = await axios.post(
				`${process.env.REACT_APP_API_URL}/api/auth/forgot-password`,
				{ email }
			);

			setMessage(res.data.message);
		} catch (err) {
			setMessage(err.response?.data?.message || "Błąd wysyłania.");
		}

		setLoading(false);
	};

	return (
		<div className="fp">
			<div className="fp-overlay">
				<div className="fp-card">
					<h1 className="fp-title">Nie pamiętasz hasła?</h1>

					<p className="fp-description">
						Podaj adres email, na który wyślemy link do resetowania hasła.
					</p>

					<form className="fp-form" onSubmit={handleSubmit}>
						<label className="fp-label">Adres email</label>
						<input
							type="email"
							className="fp-input"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							placeholder="Wpisz swój email"
							required
						/>

						<ButtonRegular type="submit" disabled={loading}>
							{loading ? "Wysyłanie..." : "Wyślij link resetujący"}
						</ButtonRegular>
					</form>

					{message && <p className="fp-message">{message}</p>}
				</div>
			</div>
		</div>
	);
}

export default PageForgotPassword;
